/**
 * HIPAA Session Timeout Warning Component
 * 
 * Features:
 * - Warning dialog 2 minutes before timeout
 * - Countdown timer
 * - "Stay Logged In" button to extend session
 * - "Logout Now" button for manual logout
 * - Modal overlay (blocks other interactions)
 * - HIPAA compliance message
 * 
 * Based on HIPAA_COMPLIANCE_COMPLETE_SECURITY_GUIDE.md
 * Frontend guide lines 1140-1168
 */

import React from 'react';
import './SessionTimeoutWarning.css';

const SessionTimeoutWarning = ({ showWarning, minutesRemaining, secondsRemaining, onExtendSession, onLogout }) => {
  if (!showWarning) {
    return null;
  }
  
  return (
    <div className="session-warning-overlay" role="dialog" aria-modal="true" aria-labelledby="timeout-title">
      <div className="session-warning-dialog">
        <div className="session-warning-icon">⏱️</div>
        
        <h2 id="timeout-title" className="session-warning-title">
          Session Expiring Soon
        </h2>
        
        <p className="session-warning-message">
          Your session will expire in{' '}
          <strong className="session-warning-timer">
            {minutesRemaining}:{secondsRemaining.toString().padStart(2, '0')}
          </strong>{' '}
          due to inactivity.
        </p>
        
        <p className="session-warning-compliance">
          This automatic timeout is required for HIPAA compliance to protect sensitive data.
        </p>
        
        <div className="session-warning-buttons">
          <button 
            onClick={onExtendSession} 
            className="btn btn-primary session-warning-btn-extend"
            autoFocus
          >
            Stay Logged In
          </button>
          <button 
            onClick={onLogout} 
            className="btn btn-secondary session-warning-btn-logout"
          >
            Logout Now
          </button>
        </div>
        
        <p className="session-warning-footer">
          Moving your mouse or typing will automatically extend your session.
        </p>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;

